import React from 'react';

import { LiaPhoneSolid, LiaEnvelope, LiaClock } from 'react-icons/lia';
import { useLanguage } from '../context/LanguageContext';

const Reservation = () => {
  const { t } = useLanguage();
  return (
    <div className="reservation">
      {/* Hero Section */}
      <section
        className="relative h-96 flex items-center justify-center parallax overlay"
        style={{
          backgroundImage: 'url(/images/DSC08741.webp)',
        }}
      >
        <div className="container mx-auto px-4 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-elegant font-bold mb-4" data-aos="fade-up">
            {t('reservation.title')}
          </h1>
          <p className="text-xl md:text-2xl" data-aos="fade-up" data-aos-delay="100">
            {t('reservation.subtitle')}
          </p>
        </div>
      </section>

      {/* Reservation Info */}
      <section className="py-12 bg-[#eee1ca]">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div data-aos="fade-up">
              <LiaPhoneSolid className="text-4xl text-[#72201e] mx-auto mb-3" />
              <h3 className="text-lg font-bold text-marrakech-dark mb-2">{t('reservation.phone')}</h3>
              <a href="tel:+212644005467" className="text-marrakech-clay hover:text-marrakech-terracotta transition">
                +2126 44 00 54 67
              </a>
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
              <LiaEnvelope className="text-4xl text-[#72201e] mx-auto mb-3" />
              <h3 className="text-lg font-bold text-marrakech-dark mb-2">{t('reservation.email')}</h3>
              <a href="mailto:reservation@janamarrakech.com" className="text-marrakech-clay hover:text-marrakech-terracotta transition">
                reservation@janamarrakech.com
              </a>
            </div>
            <div data-aos="fade-up" data-aos-delay="200">
              <LiaClock className="text-4xl text-[#72201e] mx-auto mb-3" />
              <h3 className="text-lg font-bold text-marrakech-dark mb-2">{t('reservation.hours')}</h3>
              <p className="text-marrakech-clay">
                {t('reservation.hoursText')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Reservation Iframe */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-8" data-aos="fade-up">
              <h2 className="text-4xl md:text-5xl font-elegant font-bold text-marrakech-dark mb-4">
                {t('reservation.bookYourTable')}
              </h2>
              <p className="text-lg text-marrakech-clay">
                {t('reservation.bookYourTableDesc')}
              </p>
            </div>

            <div data-aos="fade-up" data-aos-delay="100" className="bg-white rounded-lg  overflow-hidden">
              <iframe
                src="https://book.eat-now.io/fr/jana?source=janamarrakech.com"
                title="Réservation Jana Marrakech"
                className="w-full"
                style={{ height: '900px', border: 'none' }}
                frameBorder="0"
                scrolling="yes"
              ></iframe>
            </div>

          </div>
        </div>
      </section>

      {/* Additional Info */}
      {/* <section className="py-16 bg-marrakech-dark text-white">
        <div className="container mx-auto px-4 text-center" data-aos="fade-up">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Informations Importantes
          </h3>
          <div className="max-w-3xl mx-auto space-y-3 text-marrakech-sand">
            <p>• Nous recommandons de réserver à l'avance, surtout pour les weekends</p>
            <p>• Pour les groupes de plus de 10 personnes, veuillez nous contacter directement</p>
            <p>• En cas d'empêchement, merci de nous prévenir au moins 24h à l'avance</p>
            <p>• Formule All Inclusive : Buffet à volonté + Show & Ambiance</p>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Reservation;

